import { Component, OnInit, Input, ViewEncapsulation } from '@angular/core';
import { DocumentationViewComponent } from '../documentation-view.component';


@Component({
  selector: 'app-documentationnavigation',
  templateUrl: './documentation-navigation.component.html',
  styleUrls: ['./documentation-navigation.component.css'],
  encapsulation: ViewEncapsulation.None,
})
export class DocumentationNavigationComponent implements OnInit {

  @Input() contentIndex: HTMLCollection;

  constructor(private documentationView: DocumentationViewComponent,
  ) { }

  ngOnInit() {


  }

  ngOnChanges() {
  }

  PassElement(inner: string) {
    this.documentationView.ScrollToElement(inner);
  }

}


